import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Product } from '../../../Model/Catalog/Product';
import { LoginService } from '../../../Services/login.service';
import { CatalogService } from '../../../Services/CatalogManagement/catalog.service';
import { ValidationService } from '../../../Services/Validation/validation.service';
import { NpInputControlContext } from '../../../ui/inputControl/np-input-control-context';

@Component({
    selector: 'np-product-dpb',
    templateUrl: 'product-dpb.component.html',
    standalone: false
})
export class ProductDpbComponent {
    context = inject(NpInputControlContext, { optional: true });

    @Input() model: Product = new Product();
    @Output() onValueChanged = new EventEmitter<any>();

    constructor(
        public translate: TranslateService,
        public loginService: LoginService,
        public catalogService: CatalogService,
        public validationService: ValidationService
    ) {
    }

    update(event = null) {
        this.onValueChanged.emit(event);
    }

    readOnly(): boolean {
        return this.catalogService?.catalog?.isVirtual === true;
    }

    get templateView(): boolean {
        return this.context?.templateView ?? false;
    }
}
